// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2205
import { LoanCategory } from '../../../../../../../../../../types/api';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsPropertyLeased,
  IsLoanCategoryEqualTo,
  IsSystemPropertyOwnerRelatedToBorrower,
  IsPropertyOwnerAnotherBusiness,
} from '../rules';

class TaxReturnForLeasingPropCoRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isExpressPlusPropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_PLUS_PROPCO
    ).evaluate(data);
    const isExpressPropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_PROPCO
    ).evaluate(data);
    const isCorePropCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.CORE_PROPCO
    ).evaluate(data);

    const isExpressOpCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_OPCO
    ).evaluate(data);
    const isExpressPlusOpCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.EXPRESS_PLUS_OPCO
    ).evaluate(data);
    const isCoreOpCo = IsLoanCategoryEqualTo.setCategory(
      LoanCategory.CORE_OPCO
    ).evaluate(data);

    const isLeased = IsPropertyLeased.evaluate(data);
    const isLandlordRelatedToBorrower =
      IsSystemPropertyOwnerRelatedToBorrower.evaluate(data);

    const isPropertyOwnerAnotherBusiness =
      IsPropertyOwnerAnotherBusiness.evaluate(data);

    const isRequired =
      (isExpressPropCo ||
        isExpressPlusPropCo ||
        isCorePropCo ||
        isExpressOpCo ||
        isExpressPlusOpCo ||
        isCoreOpCo) &&
      isLeased &&
      isLandlordRelatedToBorrower &&
      isPropertyOwnerAnotherBusiness;

    return isRequired ? RulesetResult.REQUIRED : RulesetResult.HIDDEN;
  };
}

export default new TaxReturnForLeasingPropCoRuleset();
